import React, { Component } from 'react';
import {
  inject,
  observer,
} from 'mobx-react';
import DateTimePicker from 'react-datetime';
import FormGroup from 'react-bootstrap/lib/FormGroup';
import SideBar from '../../components/SideBar/SideBar';
import ScheduleTable from './SchedulesTable';
import BatchQueue from '../Batch/BatchQueue';
import './Schedule.css';
import { withTranslation } from 'react-i18next';
import { LoaderInline } from '../../components/PageLoading/PageLoading';
import { getLocaleName } from '../../utils/date';
import { loadRequests } from '../../utils/async';
import logger from '../../utils/logger';

@inject('scheduleStore', 'sidebarStore', 'mixStore', 'connectionStore', 'settingsStore', 'newAuthStore', 'materialStore')
@observer
class Schedules extends Component {
  componentDidMount() {
    this.mounted = true;
    const { scheduleStore, mixStore } = this.props;
    const req = [];

    if (!mixStore.allExtra.length) {
      req.push(mixStore.loadExtra);
    }
    if (!scheduleStore.customers.length) {
      req.push(scheduleStore.loadCustomers);
    }
    if (!scheduleStore.projects.length) {
      req.push(scheduleStore.loadProjects);
    }
    if (!scheduleStore.trucks.length) {
      req.push(scheduleStore.loadTrucks);
    }
    if (!scheduleStore.drivers.length) {
      req.push(scheduleStore.loadDrivers);
    }

    if (req.length) {
      loadRequests(req).then(() => logger.debug('Load async loop completed'));
    }

    this.openScheduler();
    this.search();
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  openScheduler() {
    const { settingsStore, sidebarStore } = this.props;
    const { configuration } = settingsStore;

    if (configuration && configuration.keepSchedulerOpen && !sidebarStore.type) {
      sidebarStore.onToggle('schedules');
    }
  }

  search = () => {
    const { materialStore, scheduleStore } = this.props;

    if (!materialStore.materialDetailsLoaded) {
      setTimeout(() => {
        if (this.mounted) {
          this.search();
        }
      }, 1000);
      return;
    }

    scheduleStore.loadSchedules();
  };

  onChangeDateFrom = value => {
    if (!value) {
      logger.log('DateFrom is required');
      return;
    }
    if (typeof value === 'string') {
      // Reject invalid dates
      return;
    }
    this.props.scheduleStore.dateFrom = value;
    this.search();
  };

  onChangeDateTo = value => {
    if (!value) {
      logger.log('DateTo is required');
      return;
    }
    if (typeof value === 'string') {
      // Reject invalid dates
      return;
    }
    this.props.scheduleStore.dateTo = value;
    this.search();
  };

  onAllJobsChecked = e => {
    this.props.scheduleStore.isBatched = e.target.checked;
    this.search();
  };

  validFrom = (date) => {
    if (!this.props.scheduleStore.dateTo) {
      return false;
    }
    return date.isSameOrBefore(this.props.scheduleStore.dateTo);
  };
  validTo = (date) => {
    if (!this.props.scheduleStore.dateFrom) {
      return false;
    }
    return date.isSameOrAfter(this.props.scheduleStore.dateFrom);
  };

  render() {
    const { sidebarStore, connectionStore, scheduleStore, newAuthStore, t } = this.props;
    const { areDatesInitialized, dateFrom, dateTo, newOrder, actionMode, loading } = scheduleStore;
    const { user } = newAuthStore;

    return (
      <SideBar type="schedules" title={t('Scheduler')} icon={'fa-clock'}>
        <FormGroup>
          {!connectionStore.isOnline && (
            <a className="btn btn-sm btn-default btn-add pull-right"
              title={t('Add Offline Order')}
              onClick={() => {
                sidebarStore.onToggle('orderForm');
                newOrder();
              }}>
              <i className="fa fa-plus"/>
            </a>
          )}
          <div className="input-group input-large date-picker input-daterange pull-left">
            {areDatesInitialized ? (
              <>
                <DateTimePicker
                  inputProps={{ className: 'form-control', placeholder: 'date from' }}
                  onChange={this.onChangeDateFrom}
                  value={dateFrom}
                  isValidDate={this.validFrom}
                  locale={getLocaleName(user.language)}
                />
                <span className="input-group-addon"> - </span>
                <DateTimePicker
                  inputProps={{ className: 'form-control', placeholder: 'date to' }}
                  onChange={this.onChangeDateTo}
                  value={dateTo}
                  isValidDate={this.validTo}
                  locale={getLocaleName(user.language)}
                />
              </>
            ):(
              <p>
                <i>Loading...</i>
              </p>
            )}
          </div>
          <a className="btn btn-sm btn-default btn-add"
            title={t('Search')}
            onClick={() => {
              this.search();
            }}>
            <i className="fa fa-search"/>
          </a>{' '}
          {loading && <LoaderInline/>}
        </FormGroup>

        <div className={`action-${actionMode}`}>
          <BatchQueue/>
          <ScheduleTable/>
          <ScheduleTable displayLocalOrders={true} />
        </div>

      </SideBar>
    );
  }
}

export default withTranslation()(Schedules);
